import data from "@/generated/changelog.json";

export interface Release {
  tag: string;
  name: string;
  publishedAt: string | null;
  /** Raw GitHub release notes (markdown), written for engineers. */
  body: string;
  /** User-facing summary generated from `body`; empty (falls back to `body`) if AI summarisation was skipped or failed. */
  friendlyBody: string;
}

export interface ChangelogData {
  /** Newest published release tag, e.g. "v0.3.0" — drives the "what's new" framing. */
  version: string;
  /**
   * Build-accurate version from `git describe`. On prod (deployed from a tag) this is
   * the clean tag; on staging (ahead of the last tag) it is e.g. "v0.3.0-5-ga1b2c3d".
   */
  build: string;
  generatedAt: string | null;
  releases: Release[];
}

export const changelog = data as ChangelogData;
